import React from 'react';
import { Spinner } from '@sravni/react-design-system';
import parentStyles from '../../styles.module.scss';
import styles from './styles.module.scss';

type Props = {
    value: React.ReactNode;
    caption: React.ReactNode;
    loading?: boolean;
};

export const DataLabel: React.FC<Props> = ({ value, caption, loading }) => {
    return (
        <div className={styles.dataLabel}>
            {loading && (
                <div className={styles.loadingWrapper}>
                    <Spinner />
                </div>
            )}
            <div className={parentStyles.caption}>{caption}</div>
            <div className={styles.value}>{value}</div>
        </div>
    );
};
